import { gql } from "@apollo/client";

export const FETCH_SALES_PRODUCTS = gql`
  query FETCH_SALES_PRODUCTS($company: String) {
    products(
      isSalable: true
      isActive: true
      productType: "normal"
      company: $company
    ) {
      total
      results {
        id
        odooId
        name
        number
        version
        createdAt
      }
    }
  }
`;

export const ADD_PRODUCTS_TO_PRICE_LISTS = gql`
  mutation ADD_PRODUCTS_TO_PRICE_LISTS(
    $prices: [SalesPriceInputType!]!
    $priceListIds: [Int!]!
  ) {
    addProductsToPriceLists(prices: $prices, priceListIds: $priceListIds) {
      result
    }
  }
`;

export const FETCH_SHOPIFY_PRODUCTS = gql`
  query FETCH_SHOPIFY_PRODUCTS($instance: String!, $stockCategoryId: ID!) {
    shopifyProducts(instance: $instance)
    stockCategory(id: $stockCategoryId) {
      id
      stocks {
        id
        product {
          id
          number
          name
        }
      }
    }
  }
`;
